/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
const INITIAL_CONTEXT = {
  idle: {},
  DOWNLOAD_PAYMENT_CSV: {},
};

const MACHINE_CONFIG = {
  id: 'io.vlinder.klefki.paymentTxnReport',
  initial: 'idle',
  context: INITIAL_CONTEXT,
  states: {
    idle: {
      entry: ['resetAction'],
      on: {
        START: { target: 'DOWNLOAD_PAYMENT_CSV' },
      },
    },
    DOWNLOAD_PAYMENT_CSV: {
      invoke: {
        id: 'paymentTxnReport',
        src: 'paymentTxnReport',
        onDone: {
          target: 'DOWNLOAD_PAYMENT_CSV_SUCCESS',
          actions: ['successAction'],
        },
        onError: {
          target: 'DOWNLOAD_PAYMENT_CSV_FAILED',
          actions: ['failureAction'],
        },
      },
    },
    DOWNLOAD_PAYMENT_CSV_SUCCESS: {
      on: {
        START: { target: 'DOWNLOAD_PAYMENT_CSV' },
      },
    },
    DOWNLOAD_PAYMENT_CSV_FAILED: {
      on: {
        START: { target: 'DOWNLOAD_PAYMENT_CSV' },
      },
    },
  },
};

//Machine(MACHINE_CONFIG)

export { INITIAL_CONTEXT, MACHINE_CONFIG };
